module.exports = __webpack_public_path__ + "static/media/brightness.7b6eca3d.svg";